export interface TiketUsersPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: TiketUsers[];
}

export interface TiketUsers {
  id_tiketuser?: string;
  nombre_requerimento?: string;
  descripcion?: string;
  imagenes?:UrlFotosTicketType;
  estado?: string;
  user?: string;
  fecha_creacion?: string;
  fecha_rechazo?:string;
  departamento?: string;
  motivo_rechazo?: string;
  observaciones?: string;
  estado_ticket?: string;
}

export enum EstadosTiketUserEnum {
  ABIERTO= 'ABIERTO',
  EN_PROCESO = 'EN PROCESO',
  FINALIZADO='FINALIZADO',
  RECHAZADO = 'CANCELADO',
}
export type UrlFotosTicketType = {
  id_imagen?: any[] | null;
  photosTicket?: FotosTicketType;
}

export type FotosTicketType = {
  imagen1?: FotoType;
  imagen2?: FotoType;
};
export type FotoType = {
  url: string;
  photoId: string;
  photoName: string;
};
